module.exports = __webpack_public_path__ + "img/avp_bck_alt_large@2x.48df055.webp";